module.exports = __webpack_public_path__ + "static/media/dlc-logo.85f4aa2c.85f4aa2c.png";